import { render } from "./contentBlock.vue?vue&type=template&id=3c37e9a4&ts=true"
import script from "./contentBlock.vue?vue&type=script&lang=ts"
export * from "./contentBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/contentBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c37e9a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c37e9a4', __exports__)) {
    api.reload('3c37e9a4', __exports__)
  }
  
  module.hot.accept("./contentBlock.vue?vue&type=template&id=3c37e9a4&ts=true", () => {
    api.rerender('3c37e9a4', render)
  })

}


export default __exports__